import { ReactLenis } from "lenis/react";

export const SmoothScroll = ({ children }) => (
  <ReactLenis root options={{ lerp: 0.075, smoothWheel: true, wheelMultiplier: 0.9 }}>
    {children}
  </ReactLenis>
);
